import type {
  Flow_AbstractComponent,
  Flow_Diff,
  Flow_ComponentProps,
  Flow_ObjMap,
} from 'src/types/flow-to-typescript-codemod';
import * as React from 'react';

import nameHoc from 'src/flux/nameHoc';
import classify from './classify';


export type ClassNameComponent<
  T = 'div',
  // @ts-expect-error - TS2344 - Type 'T' does not satisfy the constraint 'ForwardRefExoticComponent<any> | (new (props: any, context: any) => Component<any, {}, any>) | ((props: any) => ReactNode) | keyof IntrinsicElements'.
  I = React.ElementRef<T>,
  // @ts-expect-error TS2344
> = Flow_AbstractComponent<React.ComponentProps<T>, I>;

export default function makeClassNameComponent<C extends string>(
  baseClassName: string,
  // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'C'.
  ComponentType: C = 'div',
  name?: string,
  // @ts-expect-error TS2344
): Flow_AbstractComponent<React.ComponentProps<C>, React.ElementRef<C>> {
  // @ts-expect-error TS2322
  return React.forwardRef(
    nameComponent(
      // @ts-expect-error - TS7031 - Binding element 'className' implicitly has an 'any' type. | TS7006 - Parameter 'ref' implicitly has an 'any' type.
      ({className, ...props}, ref) => (
        // @ts-expect-error - TS2604 - JSX element type 'ComponentType' does not have any construct or call signatures.
        <ComponentType
          {...props}
          ref={ref}
          className={classify(baseClassName, className)}
        />
      ),
      `CNC(${name || ComponentType})`,
    ),
  );
}

export function makeClassNameComponentCustom<
  C extends Readonly<{
    className?: string;
  }>,
  B,
>(
  baseClassName: string,
  ComponentType: Flow_AbstractComponent<C, B>,
): Flow_AbstractComponent<C, B> {
  return React.forwardRef(
    // @ts-expect-error - TS2345 - Argument of type 'ComponentType<unknown>' is not assignable to parameter of type 'ForwardRefRenderFunction<B, unknown>'.
    nameHoc(
      // @ts-expect-error - TS2345 - Argument of type '({ className, ...props }: { [x: string]: any; className: any; }, ref: any) => Element' is not assignable to parameter of type 'ComponentType<unknown>'. | TS7031 - Binding element 'className' implicitly has an 'any' type. | TS7006 - Parameter 'ref' implicitly has an 'any' type.
      ({className, ...props}, ref) => (
        // @ts-expect-error - TS2769 - No overload matches this call.
        <ComponentType
          {...props}
          ref={ref}
          className={classify(baseClassName, className)}
        />
      ),
      ComponentType,
      'CNC',
    ),
  );
}

// @ts-expect-error - TS7006 - Parameter 'component' implicitly has an 'any' type.
function nameComponent(component, name: string) {
  component.displayName = name;
  return component;
}
